import { shopRoot as shopUrl } from '../../env.config';

export const flexaTheme = {
  flexa: {
    breakpoints: {
      md: 60
    }
  }
};

export const navbarItems = [
  { link: '/', label: 'Home' },
  {
    link: '/about-us/',
    label: 'About Us',
    menuItems: [
      { link: '/about-us/', label: 'About Us' },
      { link: '/about-us/membership/', label: 'DirectBuy Membership' },
      { link: '/v2/membership-pricing/', label: 'Membership Pricing' },
      { link: '/about-us/savings/', label: 'Life Changing Savings' },
      { link: '/about-us/my-directbuy/', label: 'My DirectBuy' },
      { link: '/about-us/my-directbuy-app/', label: 'My DirectBuy App' },
      { link: '/about-us/membership/guarantee/', label: 'Our Guarantees' },
      { link: '/about-us/press/', label: 'DirectBuy Press' }
    ]
  },
  {
    link: '/products/',
    label: 'Products',
    menuItems: [
      { link: '/featured-products/', label: 'Featured Products' },
      { link: '/products/', label: 'Products' }
    ]
  },
  {
    link: '/services/',
    label: 'Services',
    menuItems: [
      { link: '/services/', label: 'Services' },
      { link: '/services/design-services/', label: 'Design Services' },
      { link: '/services/concierge-services/', label: 'Concierge Services' },
      {
        link: '/services/project-coordination/',
        label: 'Project Coordination'
      },
      { link: '/services/delivery-services/', label: 'Delivery Services' },
      {
        link: '/services/shopping-options/',
        label: 'Shopping & Ordering Options'
      },
      { link: '/services/customer-service/', label: 'Customer Service' },
      { link: '/travel/', label: 'Travel Services' },
      { link: '/services/greensky/', label: 'Financing Services (US Only)' },
      {
        link: '/services/shield-protection-plan/',
        label: 'Shield Protection Plan'
      }
    ]
  },
  { link: '/member-stories/', label: 'Member Stories' },
  { link: '/v2/membership-pricing/', label: 'Membership' },
  { link: '/contact/', label: 'Contact Us' }
];

export const bottomNavItems = [
  { link: shopUrl, label: 'Shop' },
  { link: '/blog/', label: 'Blog' },
  { link: '/careers/', label: 'Careers' }
];
